export const takeParamsURL = () => {
  let params = new URLSearchParams(window.location.search);
  let countryiso = params.get("countryiso");
  let languageiso = params.get("languageiso");
  let detailid = params.get("detailid");
  let showDraftMode = params.get("draft");
  let originURL = window?.location?.origin;
  let darkMode = params.get("darkMode");

  //Si accede con el detailid desde el padre (iframe)
  let paramsParent = new URLSearchParams(window.parent.location.search);
  let detailidParent = paramsParent.get("detailid");

  const getDetailId = () => {
    if (detailid) {
      return detailid;
    } else if (detailidParent) {
      return detailidParent;
    }
    return "";
  };

  return {
    countryIsoParam: countryiso ? countryiso : "EN",
    languageIsoParam: languageiso ? languageiso : "en",
    detailIdParam: getDetailId(),
    showDraftModeParam: showDraftMode ? showDraftMode : false,
    originURLParam: originURL,
    darkModeParam: darkMode ? darkMode : false,
  };
};
